(function () {
  'use strict';

  var hero = document.querySelector('[data-ost-transparent-header]');
  var heroSection = document.querySelector('.ost-hero');
  var video = heroSection ? heroSection.querySelector('video') : null;

  // ── iOS: ensure playsinline is set for autoplay ───────────────────────
  if (video) {
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
  }

  // ── Transparent header ────────────────────────────────────────────────
  if (hero) {
    var colorMode = hero.getAttribute('data-header-color') || 'light';
    var glassHeader = hero.hasAttribute('data-header-glass');

    if (colorMode === 'light') {
      document.body.classList.add('ost-header-light');
    }
    if (glassHeader) {
      document.body.classList.add('ost-header-glass');
    }

    function onScroll() {
      document.body.classList.toggle('ost-at-top', window.pageYOffset < 80);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ── Play / Pause ──────────────────────────────────────────────────────
  var playPauseBtn = document.querySelector('[data-ost-playpause]');
  if (playPauseBtn && video) {
    playPauseBtn.addEventListener('click', function () {
      if (video.paused) {
        video.play();
        playPauseBtn.querySelector('[data-icon-pause]').style.display = '';
        playPauseBtn.querySelector('[data-icon-play]').style.display = 'none';
        playPauseBtn.setAttribute('aria-label', 'Pause video');
      } else {
        video.pause();
        playPauseBtn.querySelector('[data-icon-pause]').style.display = 'none';
        playPauseBtn.querySelector('[data-icon-play]').style.display = '';
        playPauseBtn.setAttribute('aria-label', 'Play video');
      }
    });
  }

  // ── Sound toggle ──────────────────────────────────────────────────────
  var soundBtn = document.querySelector('[data-ost-sound]');
  if (soundBtn && video) {
    soundBtn.addEventListener('click', function () {
      video.muted = !video.muted;
      if (video.muted) {
        soundBtn.querySelector('[data-icon-muted]').style.display = '';
        soundBtn.querySelector('[data-icon-sound]').style.display = 'none';
        soundBtn.setAttribute('aria-label', 'Unmute video');
      } else {
        soundBtn.querySelector('[data-icon-muted]').style.display = 'none';
        soundBtn.querySelector('[data-icon-sound]').style.display = '';
        soundBtn.setAttribute('aria-label', 'Mute video');
      }
    });
  }

  // ── Reduced motion: pause video ───────────────────────────────────────
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches && video) {
    video.pause();
    video.removeAttribute('autoplay');
  }

}());
